<template>
  <div>
    <div v-if="confirmation" class="d-flex align-center">
      <div v-if="showNotAnswered" class="pl-2 mb-1">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-bind="attrs" v-on="on" color="red" small>
              mdi-text-box-remove-outline
            </v-icon>
          </template>
          {{ $t('appointment.label.confirmation.notAnsweredYet') }}
        </v-tooltip>
      </div>
      <div v-if="showIsSent" class="pl-2 mb-1">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-bind="attrs" v-on="on" :color="isSent ? 'green' : 'red'" small>
              {{ isSent ? 'mdi-email-check-outline' : 'mdi-email-remove-outline' }}
            </v-icon>
          </template>
          {{ isSent ? $t('appointment.label.confirmation.emailSent') : $t('appointment.label.confirmation.emailNotSent') }}
        </v-tooltip>
      </div>
      <div v-if="!showNotAnswered && showConfirmed" class="pl-2 mb-1">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-bind="attrs" v-on="on" :color="isConfirmed ? 'green' : 'red'" small>
              {{ isConfirmed ? 'mdi-check' : 'mdi-close' }}
            </v-icon>
          </template>
          {{ isConfirmed ? $t('appointment.label.confirmation.confirmed') : $t('appointment.label.confirmation.rejected') }}
        </v-tooltip>
      </div>
      <div v-if="!showNotAnswered && isConfirmed && showIsKeysNeedsAuthorization" class="pl-2 mb-1">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-bind="attrs" v-on="on" :color="isKeysNeedsAuthorization ? 'green' : 'red'" small>mdi-key-outline</v-icon>
          </template>
          {{ isKeysNeedsAuthorization ? $t('appointment.label.confirmation.keysNeedsAuthorization') : $t('appointment.label.confirmation.keysDoesNotNeedAuthorization') }}
        </v-tooltip>
      </div>
      <div v-if="!showNotAnswered && isConfirmed && showIsAttendingToAppointment" class="pl-2 mb-1">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-bind="attrs" v-on="on" :color="isAttendingToAppointment ? 'green' : 'red'" small>
              {{ isAttendingToAppointment ? 'mdi-calendar-check-outline' : 'mdi-calendar-remove-outline' }}
            </v-icon>
          </template>
          {{ isAttendingToAppointment ? $t('appointment.label.confirmation.attendingToAppointment') : $t('appointment.label.confirmation.notAttendingToAppointment') }}
        </v-tooltip>
      </div>
      <div v-if="!showNotAnswered && showComment" class="pl-2 mb-1">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-icon v-bind="attrs" v-on="on" color="green" small>
              mdi-message-text-outline
            </v-icon>
          </template>
          {{ comment }}
        </v-tooltip>
      </div>
    </div>
    <div v-else class="d-flex align-center">
      <span>
        ---
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowConfirmedStatus',

  props: {
    confirmation: {
      type: Object
    }
  },

  computed: {
    showNotAnswered() {
      return this.confirmation?.answered == null || this.confirmation?.answered == false
    },

    showConfirmed() {
      return this.confirmation?.confirmed !== null
    },

    showIsSent() {
      return this.confirmation?.sent_at !== null
    },

    showIsKeysNeedsAuthorization() {
      return this.confirmation?.keys_needs_authorization !== null
    },

    showIsAttendingToAppointment() {
      return this.confirmation?.attending_to_appointment !== null
    },

    showComment() {
      return this.confirmation?.comment && this.confirmation?.comment.trim().length > 0
    },

    isConfirmed() {
      return this.confirmation?.confirmed
    },

    isSent() {
      return this.confirmation?.sent_at
    },

    isKeysNeedsAuthorization() {
      return this.confirmation?.keys_needs_authorization
    },

    isAttendingToAppointment() {
      return this.confirmation?.attending_to_appointment
    },

    comment() {
      return this.confirmation?.comment
    }
  },
}
</script>
